import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    handleSliderChange(values) {
        this.props.dispatch(
            Action.set('InnerSalaryCap', {
                min: parseInt(values[0]),
                max: parseInt(values[1]),
            }),
        );
    }

    render() {
        const {salaryCap, step = 100} = this.props;

        const defaultMinVal = salaryCap.getInnerCapBoundary('min');
        const defaultMaxVal = salaryCap.getInnerCapBoundary('max');
        const minVal = salaryCap.getOuterMin();
        const maxVal = salaryCap.getOuterMax();

        return (
            <SliderAdapter
                key={`slider-${defaultMinVal}-${defaultMaxVal}`}
                onChange={::this.handleSliderChange}
                min={minVal}
                max={maxVal}
                defaultValue={[defaultMinVal, defaultMaxVal]}
                thumb={<div className="circle shifted"></div>}
                minDistance={step}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {salaryCap} = state;

    return {
        salaryCap,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
